import { InjectionToken } from '@angular/core';
import { AIConfig, DEFAULT_CONFIG } from './models/ai-config.interface';

export const AI_CONFIG = new InjectionToken<AIConfig>('AI_CONFIG');

export function provideAIConfig(config?: Partial<AIConfig>) {
  return {
    provide: AI_CONFIG,
    useValue: { ...DEFAULT_CONFIG, ...config },
  };
}
